/* Carga de archivo:   elemento que carga un archivo a la vez */

//*react- recursos
import React, { useState,useEffect } from "react";
import Swal from 'sweetalert2';

//*componentes-utiles
import { A, SlidingPanel, Button } from "@reactjscomponentrepository/frontend-components/lib/components";

/* import CargaArchivo from "../../../componentes/CargaArchivo"; */

//*clases 

//*datos

//*archivos (imagenes y elementos necesarios para la rutina)

//*api's (servicios y store)

//*store's

//*vista
export default function EjemploContenido(){
  //*api store

  //*store's
  
  //*data 

  //*constantes y variables

  //*usestate
  const [abreSP, setAbreSP] = useState(false);
  const [incompletaSP, setIncompletaSP] = useState(false);  //usada para saber si esta completa la carga SP y activar botón aceptar

  //*useEffect

  //*funciones
    
   
  
    return (
      <div  className="container container-Vista">
          <h1>Ejemplo - contenido de SlidingPanel (ventana modal):</h1>
          <label>
            Aquí no tenemos componente adicional, se ejecuta todo en esta misma página
          </label>
          <br/>
          <p>coco</p>


          <br/>
      </div>
    );
}
